$(document).on('turbo:load', () => {
var fields = [];
var state = undefined;
var baselineX;
var baselineY;
$('#clickable').on("click", (event) => {
    if (state === undefined) {
    } else if (state === "coordinate-baseline") {
    $('#coordinate-baseline-x').text(event.clientX);
    $('#coordinate-baseline-y').text(event.clientY);
    baselineX = event.clientX;
    baselineY = event.clientY;
    state = undefined;

    } else if (state === "add-field") {
    var clientX = event.clientX;
    var clientY = event.clientY;

    // do the math of pixels from baseline
    var pixelsFromBaselineX = clientX - baselineX;
    var pixelsFromBaselineY = baselineY - clientY;

    // convert pixels from baseline to points from baseline
    var pointsFromBaselineX = Math.round(pixelsFromBaselineX / 1.333333333);
    var pointsFromBaselineY = Math.round(pixelsFromBaselineY / 1.333333333);

    fields.push({ x: pointsFromBaselineX, y: pointsFromBaselineY, name: $('#add-field-name').val(), page_number: $('#add-fields-page-number').val() });
    updateFields(fields);
    state = undefined;
    }
});

var updateFields = (fs) => {
    $('#fields').html("");

    for (var i = 0; i < fs.length; i++) {
    var cur = $('#fields').html();
    var add = "<div>name: " + fs[i].name + "<br />x: " + fs[i].x + "<br />y: " + fs[i].y + "<br />page: " + fs[i].page_number + "</div><br />";
    var newHtml = cur + add;
    $('#fields').html(newHtml);

    $('#fields-input').val(JSON.stringify(fields));
    }
};

$('#coordinate-baseline-btn').on("click", (event) => {
    state = "coordinate-baseline";
});

$('#add-field-btn').on("click", (event) => {
    state = "add-field";
});
});